<!-- Define templates. -->
<ng-container *ngIf="this.WorkflowHierarchyShown">
    <div class="permission-results-div">
        <table class="permission-results-table">
            <thead>
                <!-- Two header rows. -->
                <tr>
                    <td colspan="1"
                        class="permission-results-table-header-td">
                    </td>
                    <td colspan="5"
                        class="permission-results-table-header-td">
                        Build
                    </td>
                    <td colspan="5"
                        class="permission-results-table-header-td">
                        Perform
                    </td>
                </tr>
                <tr>
                    <td class="permission-results-table-header-td">Workflow State</td>

                    <td class="permission-results-table-header-td">Roles</td>
                    <td class="permission-results-table-header-td">Workflows</td>
                    <td class="permission-results-table-header-td">Forms</td>
                    <td class="permission-results-table-header-td">Folders</td>
                    <td class="permission-results-table-header-td">Form Instances</td>

                    <td class="permission-results-table-header-td">View</td>
                    <td class="permission-results-table-header-td">Edit</td>
                    <td class="permission-results-table-header-td">Delete</td>
                    <td class="permission-results-table-header-td">Grant</td>
                </tr>
            </thead>

            <tbody>
                <ng-container *ngIf="this.HasWorkflowHierarchyRecords">
                    <!-- Content rows. -->
                    <tr *ngFor="let workflowHierarchyRecord of this.WorkflowHierarchyRecords"
                        [ngClass]="permissionNode.transientIsShown ? 'shown-workflow-hierarchy-tr' : 'hidden-workflow-hierarchy-tr'">
                        <td class="permission-results-table-content-td">{{this.WorkflowStateName(workflowHierarchyRecord)}}</td>

                        <td *ngFor="let buildPermissionCellName of this.BuildPermissionCellNames;"
                            [ngClass]="(this.IsClickedPermissionName(buildPermissionCellName) ? 'clicked-permission-results-table-content-td' : 'permission-results-table-content-td')">
                            <ng-container *ngIf="this.CanBuild(workflowHierarchyRecord, buildPermissionCellName)">
                                <mat-icon class="yes-permission-mat-icon">done</mat-icon>
                            </ng-container>
                            <ng-container *ngIf="!this.CanBuild(workflowHierarchyRecord, buildPermissionCellName)">
                                x
                            </ng-container>
                        </td>

                        <td *ngFor="let performPermissionCellName of this.PerformPermissionCellNames;"
                            [ngClass]="(this.IsClickedPermissionName(performPermissionCellName) ? 'clicked-permission-results-table-content-td' : 'permission-results-table-content-td')">
                            <ng-container *ngIf="this.CanPerform(workflowHierarchyRecord, performPermissionCellName)">
                                <mat-icon class="yes-permission-mat-icon">done</mat-icon>
                            </ng-container>
                            <ng-container *ngIf="!this.CanPerform(workflowHierarchyRecord, performPermissionCellName)">
                                x
                            </ng-container>
                        </td>
                    </tr>

                    <!-- One footer row. -->
                    <tr>
                        <td class="permission-results-table-header-td">Result</td>
                        <td *ngFor="let buildPermissionCellName of this.BuildPermissionCellNames;"
                            [ngClass]="(this.IsClickedPermissionName(buildPermissionCellName) ? 'clicked-permission-results-table-content-td' : 'permission-results-table-content-td')">
                            <ng-container *ngIf="this.PermissionNodeCanBuild(buildPermissionCellName)">
                                <mat-icon class="yes-permission-mat-icon">done</mat-icon>
                            </ng-container>
                            <ng-container *ngIf="!this.PermissionNodeCanBuild(buildPermissionCellName)">
                                x
                            </ng-container>
                        </td>
                        <td *ngFor="let performPermissionCellName of this.PerformPermissionCellNames;"
                            [ngClass]="(this.IsClickedPermissionName(performPermissionCellName) ? 'clicked-permission-results-table-content-td' : 'permission-results-table-content-td')">
                            <ng-container *ngIf="this.PermissionNodeCanBuild(performPermissionCellName)">
                                <mat-icon class="yes-permission-mat-icon">done</mat-icon>
                            </ng-container>
                            <ng-container *ngIf="!this.PermissionNodeCanBuild(performPermissionCellName)">
                                x
                            </ng-container>

                        </td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
    </div>
</ng-container>
